type TFetchRequest = Partial<Request>;

const common = (): TFetchRequest => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=utf-8');
    return {
        credentials: 'include',
        headers,
    };
};

const post = (): TFetchRequest => {
    return {
        ...common,
        method: 'POST',
    };
};

const get: TFetchRequest = {
    ...common,
    method: 'GET',
};

const del: TFetchRequest = {
    ...common,
    method: 'DELETE',
};

const put: TFetchRequest = {
    ...common,
    method: 'PUT',
};

const patch: TFetchRequest = {
    ...common,
    method: 'PATCH',
};

export default {
    common: common(),
    post: post(),
    get,
    del,
    put,
    patch,
    timeout: process.env.REACT_APP_FETCH_TIMEOUT || 10000,
};
